// extracted by mini-css-extract-plugin
export var banner = "_2a-0";
export var icon = "_2a-1";
export var message = "_2a-2";